export class UpdateAgentStatusModel{
    agentAvailability:string;
    crmUserId:number;
    sessionToken:string;
}